<template>
  <Drawer
    :title="item.deviceNo + '待分配'"
    placement="right"
    :closable="true"
    v-model="openform"
    width="400"
    draggable
    class="my-drawer"
  >
    <RadioGroup v-model="model" @on-change="change">
      <Radio label="分给车辆"></Radio>
      <Radio label="分给人员"></Radio>
    </RadioGroup>

    <table id="carpersons">
      <thead>
        <tr>
          <td style="width:100px;">车牌号</td>
          <td style="width:100px;">设备号</td>
          <td style="width:100px;">扩展设备</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" :key="index" @click="selectCar(item)">
          <td>{{ item.name }}</td>
          <td>{{ item.deviceNo }}</td>
          <td>{{ item.extendDeviceNoList.join('，') }}</td>
        </tr>
      </tbody>
    </table>
  </Drawer>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      openform: false,
      item: {},
      items: [],
      model: "分给车辆",
    };
  },
  methods: {
    reachData(v) {
      console.log(v);
      this.openform = true;
      this.item = v;
      this.reset();
    },
    getList() {
      this.items = [];
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.dm + "/car/list",
        data: { groupIdList: [this.item.groupId] },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data.dataList;
        console.log(res);
        for (let i = 0; i < data.length; i++) {
          data[i].name = data[i].carNo;
          this.items.push(data[i]);
        }
      });
    },
    getPerson() {
      this.items = [];
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.dm + "/person/list",
        data: { groupIdList: [this.item.groupId] },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].name = data[i].userName;
          data[i].personId = data[i].id;
          this.items.push(data[i]);
        }
        console.log(data);
      });
    },
    change(v) {
      if (v == "分给车辆") {
        this.getList();
      } else {
        this.getPerson();
      }
    },
    selectCar(v) {
      var dd = {
        id: this.item.id,
        name: v.name,
        model: this.model,
      };
      if (this.model == "分给车辆") {
        dd.carId = v.carId;
        dd.personId = "";
      } else {
        dd.carId = "";
        dd.personId = v.personId;
      }
      this.openform = false;
      this.$emit("value", dd);
    },

    reset() {
      this.model = "分给车辆";
      this.getList();
    },
  },
};
</script>
<style lang="">
#carpersons {
  margin-top: 20px;
}
#carpersons li {
  padding: 4px 6px;
}
#carpersons li:hover {
  cursor: pointer;
  background: #ebeffe;
}
</style>


// WEBPACK FOOTER //
// src/components/information/binecarperson.vue